import { logger } from '@/lib/logger.client';

import { ApiResponse } from '../http/BaseHttpClient';
import AbstractService from './AbstractService';

type NewsLetterResponse = any;

export class NewsLetterService extends AbstractService {
  /**
   * Subscribe an email to the newsletter
   *
   * @param email
   * @returns
   */
  async subscribe(email: string): Promise<void> {
    try {
      const response = await this.post<NewsLetterResponse>(this.endpoint('subscribeNewsletter'), { email }, { timeout: 10000 });
      const data = (response as any)?.data ?? response;

      if ((data as any)?.error) {
        throw new Error((data as any).error?.message || 'Failed to subscribe to newsletter');
      }

      return data;
    } catch (error: any) {
      logger.error({
        message: 'NewsLetterService:subscribe failed',
        error: error?.message,
      });
    }
  }
}

export const newsletterService = new NewsLetterService();
